import { c as _c } from "react/compiler-runtime";
import { makeStyles } from '@mui/styles';
import Button from '@classify/react-core-components/Button';
import PeopleItem from '../PeopleItem';
const useStyles = makeStyles(({
  spacing,
  breakpoints
}) => ({
  root: {
    marginTop: spacing(2)
  },
  action: {
    textAlign: 'right',
    padding: spacing(1, 0),
    flexGrow: 1
  },
  [breakpoints.up('sm')]: {
    root: {
      display: 'flex'
    }
  }
}));
export default function SelectedPeople(t0) {
  const $ = _c(18);
  const {
    people,
    translations,
    onConfirm: t1
  } = t0;
  const onConfirm = t1 === undefined ? _temp : t1;
  const classes = useStyles();
  let t2;
  if ($[0] !== people.avatar || $[1] !== people.displayName || $[2] !== people.id || $[3] !== people.subHeading) {
    t2 = <div><PeopleItem userId={people.id} userName={people.displayName} subHeading={people.subHeading} avatarUrl={people.avatar} /></div>;
    $[0] = people.avatar;
    $[1] = people.displayName;
    $[2] = people.id;
    $[3] = people.subHeading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== onConfirm || $[6] !== people) {
    t3 = () => onConfirm(people);
    $[5] = onConfirm;
    $[6] = people;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t3 || $[9] !== translations.confirmSelection) {
    t4 = <Button onClick={t3}>{translations.confirmSelection}</Button>;
    $[8] = t3;
    $[9] = translations.confirmSelection;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== classes.action || $[12] !== t4) {
    t5 = <div className={classes.action}>{t4}</div>;
    $[11] = classes.action;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== classes.root || $[15] !== t2 || $[16] !== t5) {
    t6 = <div className={classes.root}>{t2}{t5}</div>;
    $[14] = classes.root;
    $[15] = t2;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp() {}